'<template>
  <div class="home-layout-header"  ref="titleRef">
    <section class="title-section">
      <div class="tab-list">
        <div
            class="tab-item"
            :class="tabClass(viewMode, 'cltn')"
            @click="toggleViewMode('cltn')"
        >
          {{ $t('home.myEvent') }}
        </div>
        <div
            class="tab-item"
            :class="tabClass(viewMode, 'nft')"
            @click="toggleViewMode('nft')"
        >
          {{ $t('home.myNft') }}
        </div>
      </div>
      <div @click="routeSearch" class="title-right">
        <search-svg class="cursor-pointer"/>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from 'vue';
import SearchSvg from '@/components/svg/SearchSvg.vue';
import {useHomeListConfig, useHomeListModeConfig} from '@/script/homeScript';
import {store} from '@/store';
import {useRoute, useRouter} from 'vue-router';
import {HomeViewType} from '@/models/types';

export default defineComponent({
  name: 'HomeLayoutHeader',
  components: {
    SearchSvg,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const titleRef = ref()
    const {
      listMode,
      changeMode,
    } = useHomeListModeConfig()

    const {
      viewMode,
      toggleViewMode,
    } = useHomeListConfig()
    const tabClass = (mode: HomeViewType, type: HomeViewType) => {
      return mode === type ? 'selected' : ''
    }

    const routeSearch = () => {
      if (route.name === "SearchView") {
        return;
      } else {
        store.commit("search/INIT_SEARCH", null);
      }
      router.push({name: 'SearchView'})
    }

    return {
      titleRef,
      listMode,
      viewMode,
      changeMode,
      routeSearch,
      toggleViewMode,
      tabClass,
    }
  }
})
</script>
